<template>
  <div>
    <div class="verification-report-box" v-show="show">
      <div class="report-main">
        <div
          class="report-scroll"
          :style="{ 'max-height': showBtn ? '480px' : '550px' }"
        >
          <div
            class="top"
            :style="{
              backgroundImage:
                checkRes.check_status == 6
                  ? `url(${backgroundImageA})`
                  : `url(${backgroundImageB})`,
            }"
          >
            <div class="top-left">
              <div class="top-left-tip">{{ dealResultText }}</div>
              <div class="title">官方验号报告</div>
            </div>
            <div
              class="top-right"
              v-if="clientType == 'seller' && checkStatus == 5 && roomId"
              @click="
                $openIM({
                  im_type: 3,
                  roomId: roomId,
                })
              "
            >
              联系客服
              <i class="el-icon-caret-right"></i>
            </div>
          </div>
          <div class="middle">
            <div class="item-wrapper">
              <div class="item-title">
                <img
                  :src="
                    checkRes.check_status == 6
                      ? require('@/assets/image/PersonalCenter/Seller/BargainPrice/productIcon1.png')
                      : require('@/assets/image/PersonalCenter/Seller/BargainPrice/productIcon.png')
                  "
                  alt=""
                />
                商品信息
              </div>
              <div class="item">
                <div>商品ID</div>
                <div>{{ checkRes.unique_no }}</div>
              </div>
              <div class="item">
                <div>游戏名称</div>
                <div>{{ checkRes.game_name }}</div>
              </div>
              <div class="item">
                <div>游戏账号</div>
                <div>{{ checkRes.game_account }}</div>
              </div>
              <div
                class="item"
                v-for="item in checkRes.category"
                :key="item.value"
              >
                <div>{{ item.name }}</div>
                <div>{{ item.value }}</div>
              </div>
            </div>
            <div class="item-wrapper">
              <div class="item-title">
                <img
                  :src="
                    checkRes.check_status == 6
                      ? require('@/assets/image/PersonalCenter/Seller/BargainPrice/verificationIcon3.png')
                      : require('@/assets/image/PersonalCenter/Seller/BargainPrice/verificationIcon.png')
                  "
                  alt=""
                />
                验号内容
              </div>
              <div
                class="official-title"
                :style="{
                  backgroundImage:
                    checkRes.check_status == 6
                      ? `url(${backgroundImageD})`
                      : `url(${backgroundImageC})`,
                }"
              >
                官网截图
              </div>
              <div
                class="official-img ql-container ql-snow"
                v-if="checkRes.product_image"
              >
                <p class="ql-editor" v-html="checkRes.product_image"></p>
              </div>
              <div
                class="official-img ql-container ql-snow"
                v-if="checkRes.cdata"
              >
                <p class="ql-editor" v-html="checkRes.cdata"></p>
              </div>
              <div
                class="official-title"
                v-if="checkRes.img_url"
                :style="{
                  backgroundImage:
                    checkRes.check_status == 6
                      ? `url(${backgroundImageD})`
                      : `url(${backgroundImageC})`,
                }"
              >
                补充截图
              </div>
              <div class="official-img" v-if="checkRes.img_url">
                <img
                  v-for="(item, index) in checkRes.img_url"
                  :src="item"
                  :key="index"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="bottom-btn" v-if="showBtn">
          <div class="btn" @click="abandonShow = true">放弃</div>
          <el-button class="btn" :loading="btnLoading" @click="confirmCheck">确认验号</el-button>
        </div>
      </div>
      <div class="close">
        <img
          src="@/assets/image/AccountDeal/close.png"
          @click="$emit('update:show', false)"
        />
      </div>
    </div>
    <!-- <my-dialog
      :show="groupShow"
      title="温馨提示"
      :text="text"
      :close-fun="cancel"
    >
      <div class="footer-btn" slot="btn">
        <el-button class="dialog-btn" @click="cancel">取消</el-button>
        <el-button class="dialog-btn confirm" @click="goGroup">{{
          btnText
        }}</el-button>
      </div>
    </my-dialog> -->
    <!-- 放弃账号 -->
    <my-dialog
      width="453"
      :show="abandonShow"
      :close-fun="() => (abandonShow = false)"
      :btnFuc="abandonAcount"
      title="放弃原因"
      btnText="确认放弃"
      custom-class="tipDialog check-dialog"
    >
      <template slot="content">
        <div class="check-reason">
          <el-input
            v-model="reason"
            :placeholder="placeholder"
            type="textarea"
            show-word-limit
            :maxlength="300"
            :rows="4"
            :autosize="{ minRows: 4, maxRows: 7 }"
            resize="none"
          ></el-input>
        </div>
      </template>
    </my-dialog>
  </div>
</template>

<script>
import myDialog from "@/components/myDialog.vue";
import { verifyReport, verifyPass, verifyGiveUp } from "@/request/API";
import Bus from "@/util/eventBus";
export default {
  name: "verificationReport",
  components: {
    myDialog,
  },
  props: {
    // 是否显示
    show: {
      type: Boolean,
      default: false,
    },
    showBtn: {
      type: Boolean,
      default: false,
    },
    id: {
      type: [Number, String],
      default: "",
    },
    // 验号状态
    checkStatus: {
      type: [Number, String],
      default: "",
    },
    // 房间id
    roomId: {
      type: [Number, String],
      default: "",
    },
    reportData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    clientType: {
      type: String,
      default: "",
    },
    showDetail: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      groupShow: false,
      custom: "",
      second: 3,
      abandonShow: false,
      reason: "",
      checkRes: {},
      // A B top大背景图
      backgroundImageA: require("../../../assets/image/PersonalCenter/Seller/BargainPrice/verificationReportBg1.png"),
      backgroundImageB: require("../../../assets/image/PersonalCenter/Seller/BargainPrice/verificationReportBg.png"),
      // C D 官方截图 补充截图标题背景
      backgroundImageC: require("../../../assets/image/PersonalCenter/Seller/BargainPrice/verificationIcon2.png"),
      backgroundImageD: require("../../../assets/image/PersonalCenter/Seller/BargainPrice/verificationIcon4.png"),
      btnLoading: false
    };
  },
  computed: {
    placeholder() {
      return this.id
        ? "请填写您的放弃原因"
        : "如果有需要特别验证的内容请备注告知";
    },
    // text() {
    //   return `您已确认当前验号报告，游严选交付客服${this.custom}将为您提供交付服务`;
    // },
    // btnText() {
    //   return `进群${this.second}S`;
    // },
    dealResultText() {
      switch (this.clientType) {
        case "buyer":
          if (this.showBtn) {
            return "请确认验号报告";
          } else {
            if (this.checkRes.check_status == 5) {
              return "您已验号成功";
            } else if (this.checkRes.check_status == 6) {
              return "您已放弃验号";
            }
          }
        case "seller":
          if (this.checkRes.check_status == 5) {
            return "买家已验号成功";
          } else if (this.checkRes.check_status == 6) {
            return "买家已放弃验号";
          }
        default:
          return "";
      }
    },
  },
  watch: {
    show(val) {
      if (val) {
        this.touchmoveDisable();
        // 获取验号信息
        if (this.id) {
          verifyReport({
            order_id: this.id,
          }).then((res) => {
            this.checkRes = res.data;
          });
        } else if (Object.keys(this.reportData).length > 0) {
          this.checkRes = this.reportData;
        }
      } else {
        if (!this.showDetail) this.touchmoveY();
      }
    },
  },
  methods: {
    countDown() {
      this.timer = setInterval(() => {
        this.second--;
        if (this.second == 0) {
          this.groupShow = false;
          //  进群
          this.goGroup();
          this.$nextTick(() => {
            this.second = 3;
          });
          clearInterval(this.timer);
        }
      }, 1000);
    },
    cancel() {
      if (this.timer) clearInterval(this.timer);
      this.groupShow = false;
      //  进群
      this.second = 3;
    },
    goGroup() {
      this.cancel();
      //  关闭弹窗
      Bus.$emit("closeDialog");
      this.$openIM({
        im_type: 3,
        roomId: this.checkRes.group_room_id,
      });
      this.$emit("update:show", false);
      Bus.$emit("reFresh");
    },
    // 放弃账号
    abandonAcount() {
      verifyGiveUp({
        order_id: this.checkRes?.earnest_order_id || this.id,
        reason: this.reason,
      })
        .then((res) => {
          this.abandonShow = false;
          this.$emit("update:show", false);
          Bus.$emit("reFresh");
          this.$message({
            message: res.msg,
            customClass: "counteroffer-msg",
          });
        })
        .catch((err) => {
          this.$message.error(err.msg);
        });
    },
    //  确认验号
    confirmCheck() {
      this.btnLoading = true
      verifyPass({
        order_id: this.checkRes.earnest_order_id,
      })
        .then((res) => {
          this.$emit("update:show", false);
          Bus.$emit("reFresh");
          // this.groupShow = true;
          // this.$nextTick(() => {
            // this.$emit("update:show", false);
            // Bus.$emit("reFresh");
            // this.countDown();
          // });
        })
        .catch((err) => {
          this.$message.error(err.msg);
        }).finally(()=>{
          this.btnLoading = false
        })
    },
    /**
     * @description: 禁止页面滑动
     * @return {*}
     */
    touchmoveDisable() {
      let body = document.getElementsByTagName("body");
      body[0].style.overflow = "hidden";
    },
    /**
     * @description: 页面滑动
     * @return {*}
     */
    touchmoveY() {
      let body = document.getElementsByTagName("body");
      body[0].style.removeProperty("overflow");
    },
  },
};
</script>

<style lang="less" scoped>
.verification-report-box {
  width: 100vw;
  height: 100vh;
  background: rgba(15, 23, 42, 0.48);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1002;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  .report-main {
    width: 596px;
    height: 550px;
    border-radius: 4px;
    background: var(--bg-tag, #F0EDE8);
    box-sizing: border-box;
    overflow: hidden;
    filter: drop-shadow(0 18px 46px rgba(26, 29, 36, 0.14));
    .report-scroll {
      overflow-y: auto;
      overflow-x: hidden;
      &::-webkit-scrollbar {
        width: 4px; /* 滚动条宽度 */
        height: 4px;
      }

      &::-webkit-scrollbar-track {
        background-color: transparent; /* 滚动条背景色 */
      }

      &::-webkit-scrollbar-thumb {
        background-color: var(--border-strong, #D8D2CA); /* 滚动条滑块颜色 */
        border-radius: 4px;
      }
    }
    .top {
      // background: url("../../../assets/image/PersonalCenter/Seller/BargainPrice/verificationReportBg.png")
      //   no-repeat;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center top;
      width: 100%;
      height: 240px;
      display: flex;
      // align-items: center;
      justify-content: space-between;
      padding: 43px 50px 0 52px;
      box-sizing: border-box;
      &-left {
        &-tip {
          color: #fff;
          font-family: PingFang SC;
          font-size: 14px;
          font-style: normal;
          font-weight: 500;
          line-height: normal;
        }
        .title {
          color: #fff;
          font-family: ZhenyanGB;
          font-size: 24px;
          font-style: normal;
          font-weight: 400;
          line-height: 36px; /* 150% */
          letter-spacing: 2px;
        }
      }
      &-right {
        cursor: pointer;
        color: #fff;
        text-align: center;
        font-family: PingFang SC;
        font-size: 13.715px;
        font-style: normal;
        font-weight: 400;
        border-radius: 4px;
        border: 1px solid #fff;
        background: rgba(255, 255, 255, 0.1);
        width: 100px;
        height: 30px;
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 20px;
        i {
          line-height: 16px;
        }
      }
    }
    .middle {
      padding: 0 29px 12px;
      transform: translateY(-110px);
      margin-bottom: -110px;
      .item-wrapper {
        margin-right: -4px;
        margin-left: -4px;
        border-radius: 4px;
        background: var(--bg-card, #fff);
        border: 1px solid var(--border-soft, #E8E4DE);
        padding: 0 26px 10px 21px;
        margin-bottom: 12px;
        box-shadow: 0 8px 18px rgba(26, 29, 36, 0.06);
        .item-title {
          height: 48.4px;
          display: flex;
          align-items: center;
          color: var(--text-main, #111827);
          font-family: PingFang SC;
          font-size: 16px;
          font-style: normal;
          font-weight: 500;
          line-height: 17.513px; /* 109.456% */
          border-bottom: 1px solid var(--border-soft, #E8E4DE);
          img {
            width: 33px;
            height: 33px;
          }
        }
        .item {
          margin-top: 12px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          color: var(--text-secondary, #5A5F6B);
          font-family: PingFang SC;
          font-size: 14px;
          font-style: normal;
          font-weight: 500;
          line-height: normal;
        }
        .official-title {
          margin-top: 10px;
          height: 20px;
          color: var(--text-main, #111827);
          font-family: PingFang SC;
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
          // background: url("../../../assets/image/PersonalCenter/Seller/BargainPrice/verificationIcon2.png");
          background-repeat: no-repeat;
          background-position: bottom left;
        }
        .official-img {
          width: 100%;
          margin-top: 11px;
          img {
            width: 100%;
            display: block;
            margin-bottom: 10px;
            object-fit: cover;
          }
        }
        .ql-container.ql-snow {
          border: none;
          .ql-editor {
            padding: 0;
            margin: 0;
          }
        }
      }
    }
    .bottom-btn {
      width: 596px;
      height: 70px;
      box-sizing: border-box;
      border-radius: 0px 0px 4px 4px;
      background: var(--bg-card, #fff);
      border-top: 1px solid var(--border-soft, #E8E4DE);
      display: inline-flex;
      padding: 15px 99px;
      justify-content: space-between;
      align-items: center;
      .btn {
        display: flex;
        width: 189px;
        height: 40px;
        justify-content: center;
        align-items: center;
        border-radius: 4px;
        border: 1.5px solid var(--bg-dark, #1A1D24);
        color: var(--text-main, #1A1D24);
        background: var(--bg-card, #FFFFFF);
        cursor: pointer;
        transition: box-shadow .2s ease, opacity .2s ease, background .2s ease;
        &:hover{
          background: var(--bg-tag, #F0EDE8);
        }
        &:last-child {
          color: #FFFFFF;
          overflow: hidden;
          margin-left: 20px;
          border-color: transparent;
          background: var(--primary, #FF5A1F);
          &:hover{
            background: var(--primary-hover, #E84A12);
            box-shadow: 0 10px 22px rgba(255, 90, 31, 0.20);
            opacity: 1;
          }
        }
      }
    }
  }
  .close {
    margin-top: 10px;
    img {
      cursor: pointer;
      width: 30px;
      height: 30px;
    }
  }
}
/deep/.check-reason {
  width: calc(100% - 40px);
  background: var(--bg-tag, #F0EDE8);
  border: 1px solid var(--border-soft, #E8E4DE);
  padding: 10px 20px;
  border-radius: 4px;
  margin-bottom: 30px;
  margin-top: 20px;
  .reason {
    background: transparent;
    font-weight: 500;
    letter-spacing: 0.28px;
    color: var(--text-main, #111827);
    line-height: 20px;
  }
  .el-textarea__inner {
    border: none;
    background: transparent;
    padding: 0;
    color: var(--text-main, #111827);
    .font() {
      font-size: 12px;
      color: var(--text-muted, #9AA0AC);
      font-weight: 400;
      letter-spacing: 0.24px;
      line-height: 20px;
    }
    &::-webkit-input-placeholder {
      /* 使用webkit内核的浏览器 */
      .font();
    }
    &:-moz-placeholder {
      /* Firefox版本4-18 */
      .font();
    }
    &::-moz-placeholder {
      /* Firefox版本19+ */
      .font();
    }
    &:-ms-input-placeholder {
      /* IE浏览器 */
      .font();
    }
  }
  .el-input__count {
    background: transparent;
  }
}
.dialog-btn {
  width: 140px;
  height: 40px;
  color: var(--text-main, #1A1D24);
  text-align: center;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  border: 1.5px solid var(--bg-dark, #1A1D24);
  border-radius: 4px;
  background: var(--bg-card, #FFFFFF);
  &.confirm {
    border: none;
    color: #FFFFFF;
    background: var(--primary, #FF5A1F);
  }
}
</style>
<style lang="less">
.counteroffer-msg {
  border-radius: 4px;
  background: var(--primary-soft, #FCEDE5);
  padding: 10px 43px;
  z-index: 9999999;
  .el-message__icon {
    display: none;
  }
  .el-message__content {
    color: var(--hot, #FF2D55);
    text-align: center;
    font-family: PingFang SC;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
  }
}
</style>
